import HomepageBookCallButton from './HomepageBookCallButton'

function HomepageFinalCta() {
    return (
        <section className="relative overflow-hidden bg-[#3F454F] px-5 py-[84px] text-center md:px-0">
            <div className="pointer-events-none absolute left-1/2 top-[-160px] h-[600px] w-[600px] -translate-x-1/2 rounded-full bg-[radial-gradient(circle,rgba(237,92,47,0.18)_0%,transparent_65%)]" />
            <div className="pointer-events-none absolute bottom-[-200px] right-[-100px] h-[500px] w-[500px] rounded-full bg-[radial-gradient(circle,rgba(250,179,49,0.12)_0%,transparent_65%)]" />
            <div className="relative z-10 mx-auto max-w-[740px]">
                <h2 className="mb-4 text-[clamp(26px,3.2vw,44px)] font-extrabold leading-[1.12] tracking-[-0.025em] text-white">
                    <span>Ready to make direct mail a </span>
                    <span className="bg-[linear-gradient(95deg,#F28230_0%,#FAB331_100%)] bg-clip-text text-transparent">
                        serious growth channel?
                    </span>
                </h2>
                <p className="mx-auto mb-8 max-w-[540px] text-[17px] leading-[1.65] text-white/[0.72]">
                    Talk with our team about your goals, budget, audience, and
                    current direct mail strategy. We&apos;ll help you choose the
                    most effective path forward.
                </p>
                <HomepageBookCallButton
                    variant="light"
                    className="px-8 py-[15px] text-[15px] font-extrabold text-[#3F454F] shadow-[0_8px_24px_-4px_rgba(0,0,0,0.25)] hover:shadow-[0_12px_32px_-4px_rgba(0,0,0,0.35)]">
                    Book a Strategy Call
                </HomepageBookCallButton>
            </div>
        </section>
    )
}

export default HomepageFinalCta
